<template>
  <div
    v-if="tags && tags.length"
    class="d-flex flex-wrap gap-2">
    <v-chip
      v-for="(tag, index) in tags"
      :key="index + tag"
      color="black"
      class="fs-10 text-uppercase"
      text-color="white">
      {{ tag }}
    </v-chip>
  </div>
</template>

<script>
export default {
  name: 'AppListTags',
  props: {
    tags: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
